// utils/imageHelper.js
import { getApiUrl, API_ENDPOINTS } from '../config/apiConfig';

const API_BASE = getApiUrl(API_ENDPOINTS.PROXY_IMAGE);

export const getImageUrl = (path, size = 'w500') => {
  // Path kontrolü - boş, null, undefined veya sadece whitespace ise data URI döndür
  if (!path || path === 'null' || path === 'undefined' || (typeof path === 'string' && path.trim() === '')) {
    // Path yoksa direkt data URI döndür (placeholder spam'ı önlemek için)
    return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iIzExMSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTIiIGZpbGw9IiM2NjYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5SZXNpbSBZb2s8L3RleHQ+PC9zdmc+';
  }
  
  // String'e çevir ve trim yap
  path = String(path).trim();
  
  // Eğer path zaten proxy URL ise direkt döndür
  if (path.includes('/proxy-image.php')) return path;
  
  // Zaten data URI ise direkt döndür
  if (path.startsWith('data:')) return path;
  
  // Eğer path tam bir TMDB URL'si ise, sadece path kısmını çıkar
  if (path.includes('image.tmdb.org')) {
    const match = path.match(/\/t\/p\/[^/]+\/(.+)$/);
    if (match) {
      path = '/' + match[1];
    }
  }
  
  // Path'i normalize et - başında / olmalı (http/https ile başlamıyorsa)
  let normalizedPath = path;
  if (!normalizedPath.startsWith('/') && !normalizedPath.startsWith('http')) {
    normalizedPath = '/' + normalizedPath;
  }
  
  // URL encode et
  return `${API_BASE}?path=${encodeURIComponent(normalizedPath)}&size=${size}`;
};

export const getPosterUrl = (path, size = 'w500') => getImageUrl(path, size);
export const getBackdropUrl = (path, size = 'w1280') => getImageUrl(path, size);

/**
 * Profil resim URL'lerini (avatar, banner) normalize eder
 * Yanlış formatları düzeltir: https// -> https://, çift slash'ları düzeltir
 */
export const normalizeProfileImageUrl = (url) => {
  if (!url || url === 'null' || url === 'undefined' || (typeof url === 'string' && url.trim() === '')) {
    return null;
  }
  
  let normalizedUrl = typeof url === 'string' ? url.trim() : String(url);
  
  // Eğer zaten placeholder veya external URL ise direkt döndür
  if (normalizedUrl.includes('placeholder') || 
      normalizedUrl.includes('ui-avatars') || 
      normalizedUrl.includes('picsum') ||
      normalizedUrl.startsWith('data:')) {
    return normalizedUrl;
  }
  
  // Yanlış formatları düzelt: https// -> https://, çift slash'ları düzelt
  normalizedUrl = normalizedUrl.replace(/https?\/\//g, (match) => {
    // https// veya http// -> https:// veya http://
    return match.replace(/\//, '://');
  });
  normalizedUrl = normalizedUrl.replace(/https:\/\/https:\/\//g, 'https://'); // Çift protokolü düzelt
  normalizedUrl = normalizedUrl.replace(/http:\/\/https:\/\//g, 'https://'); // http://https:// -> https://
  normalizedUrl = normalizedUrl.replace(/([^:]\/)\/+/g, '$1'); // Çift slash'ları düzelt (:// hariç)
  
  // Eğer http:// veya https:// ile başlamıyorsa ve / ile başlıyorsa, domain ekle
  if (normalizedUrl.startsWith('/') && !normalizedUrl.startsWith('//')) {
    // API base URL'den domain'i çıkar
    const apiUrl = getApiUrl(API_ENDPOINTS.PROXY_IMAGE);
    const domainMatch = apiUrl.match(/^(https?:\/\/[^\/]+)/);
    if (domainMatch) {
      normalizedUrl = domainMatch[1] + normalizedUrl;
    }
  }
  
  return normalizedUrl;
};